export enum Scopes {
  ResourceOwnerId = 'urn:zitadel:iam:user:resourceowner:id',
  ResourceOwnerName = 'urn:zitadel:iam:user:resourceowner:name',
  ResourceOwnerPrimaryDomain = 'urn:zitadel:iam:user:resourceowner:primary_domain',
  ProjectRoles = 'urn:zitadel:iam:org:project:roles',
}
